import { render, staticRenderFns } from "./Public.vue?vue&type=template&id=10b23e3e&scoped=true&"
import script from "./Public.vue?vue&type=script&lang=ts&"
export * from "./Public.vue?vue&type=script&lang=ts&"
import style0 from "./Public.vue?vue&type=style&index=0&id=10b23e3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b23e3e",
  null
  
)

export default component.exports